import { useEffect, useState } from "react";

// Editorial "mainframe-style" decorative strip rendered just under the navbar.
// Hairlines, tick marks, tiny uppercase metadata and a live status dot —
// purely decorative, no interactive behavior.
export default function MetaStrip() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hh = String(now.getHours()).padStart(2, "0");
  const mm = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");

  return (
    <div
      aria-hidden
      className="hidden lg:block w-full px-10 select-none pointer-events-none"
    >
      {/* Top hairline with end-cap ticks */}
      <div className="relative h-[2px] w-full">
        <div className="absolute inset-0 bg-[#1C2E1E]/80" />
        <span className="absolute -top-2 left-0 w-[2px] h-[14px] bg-[#1C2E1E]" />
        <span className="absolute -top-2 right-0 w-[2px] h-[14px] bg-[#1C2E1E]" />
        {/* Inner micro ticks for editorial rhythm */}
        {[0.18, 0.34, 0.5, 0.66, 0.82].map((p) => (
          <span
            key={p}
            style={{ left: `${p * 100}%` }}
            className="absolute -top-1 w-[2px] h-[8px] bg-[#1C2E1E]/80"
          />
        ))}
      </div>

      {/* Meta row */}
      <div className="mt-3 flex items-center justify-between text-[11px] font-sans font-medium uppercase tracking-[0.22em] text-[#1C2E1E]">
        {/* Left cluster — index + edition */}
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1.5">
            <span className="inline-block w-[5px] h-[5px] rounded-full bg-[#1C2E1E]/80" />
            <span>IDX — 048</span>
          </span>
          <span className="w-[2px] h-3.5 bg-[#1C2E1E]/70" />
          <span>Edition 06 / 2026</span>
          <span className="w-[2px] h-3.5 bg-[#1C2E1E]/70" />
          <span>Vol. IV</span>
        </div>

        {/* Center cluster — coordinates */}
        <div className="flex items-center gap-3">
          <span>41.85°N</span>
          <span className="inline-block w-4 h-[2px] bg-[#1C2E1E]/80" />
          <span>87.65°W</span>
          <span className="inline-block w-4 h-[2px] bg-[#1C2E1E]/80" />
          <span>Chicago — IL</span>
        </div>

        {/* Right cluster — live status + local time */}
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-1.5">
            <span className="relative flex w-[6px] h-[6px]">
              <span className="absolute inset-0 rounded-full bg-emerald-500/70 animate-ping" />
              <span className="relative w-[6px] h-[6px] rounded-full bg-emerald-600" />
            </span>
            <span>Studio Open</span>
          </span>
          <span className="w-[2px] h-3.5 bg-[#1C2E1E]/70" />
          <span className="tabular-nums tracking-[0.18em]">
            {hh}:{mm}:{ss} CT
          </span>
        </div>
      </div>
    </div>
  );
}